import firebase from '@/services/firebase/firebase';
import helpers from '@/utils/helpers';
import validations from '@/utils/validations';
import {
  FB_BUY_PAYMENT_FAILURE,
} from '@/utils/const';

const paymentMixin = {
  data() {
    return {
      ...validations,
      loading: false,
      stkValid: false,
      paymentInitiated: false,
      notificationAllowed: true,
      notificationDenied: false,
      paymentRetry: false,
      statusLoaded: false,
      paymentStatus: 'PENDING',
      timeoutId: null,
      mpesaRef: null,
      paybillLoading: false,
      isFilled: false,
      waiting: false,
    };
  },

  mounted() {
    this.initializeNotificationPermissions();
    this.setupPaymentEventListeners();
  },

  beforeDestroy() {
    this.cancelTimeout();
  },

  methods: {
    /**
     * Initialize notification permission state
     */
    initializeNotificationPermissions() {
      if (firebase.messaging.isSupported()) {
        if (Notification.permission === 'default') {
          this.notificationAllowed = false;
        }
        if (Notification.permission === 'denied') {
          this.notificationDenied = true;
        }
      }
    },

    /**
     * Setup event listeners for payment status
     */
    setupPaymentEventListeners() {
      this.$root.$on('failed-payment', () => {
        this.paymentRetry = true;
        this.paymentStatus = 'FAILED';
        this.cancelTimeout();
        this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
      });
      this.$root.$on('successful-payment', () => {
        this.cancelTimeout();
      });
    },

    /**
     * Request browser notification permission
     */
    requestNotification() {
      this.notificationAllowed = true;
      this.notificationDenied = false;
      this.$root.$emit('request-notification');
    },

    /**
     * Clear payment status timeout
     */
    cancelTimeout() {
      clearTimeout(this.timeoutId);
    },
  },

  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },

  directives: {
    uppercase: {
      bind(el, _, vnode) {
        el.addEventListener('keyup', (e) => {
          e.target.value = e.target.value.toUpperCase();
          vnode.componentInstance.$emit('input', e.target.value.toUpperCase());
        });
      },
    },
  },
};

export default paymentMixin;
